module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-CODEPEN.3daa5540.png";